module.exports = __webpack_public_path__ + "img/type_FIGHTING.b6d3f059.png";